import NewsList from "../components/NewsList";

const ListNewsPage = () => {
  return (
    <NewsList />
  );
};

export default ListNewsPage;
